module.exports = __webpack_public_path__ + "static/media/alladin2.26ab850f.gif";